import React from 'react'
import Code from '../components/code'
import { dhagaJS } from '../dhaga'

export default function DhagaCode() {
    
    return (
        <div className='text-sm'>
            <Code localStorageCode="dhaga-code" localStorageOriginalCode="dhaga-code-original" mainFunction={dhagaJS} to="/dhaga-console" logo="dhaga-logo.png"/>
        </div>
    )
}
